import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import styled from "styled-components";
import { useSelections } from "../../context/Selections";
import NativeObject from "../../components/NativeObject/NativeObject";
import Card from "../../components/Cards/Card";
import PeformanceTimeDesktop from "./Components/PeformanceTime";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "94%",
  justifyContent: "flex-start",
  width: "100%",
});

function OpportunitiesDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Radiografia dos PDVs");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const handleChange = (event) => {
    app.field("Desc_pdvpremiado").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Desc_pdvpremiado")
        : null;
      setSelectedValue(distributors?.qSelected);
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);
  return (
    <div className="app oportunidades">
      <div className="appContent">
        <FormControl className="container-form-control">
          <RadioGroup
            defaultValue={selectedValue}
            row
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "20px" }}
          >
            <FormControlLabel
              value="Radiografia dos PDVs"
              sx={{
                color: "#212121",
              }}
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#ff3b49",
                    "&.Mui-checked": {
                      color: "#ff3b49",
                    },
                  }}
                />
              }
              label="Radiografia dos PDVs"
            />

            <FormControlLabel
              value="Peformance no tempo"
              sx={{
                color: "#212121",
              }}
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#ff3b49",
                    "&.Mui-checked": {
                      color: "#ff3b49",
                    },
                  }}
                />
              }
              label="Peformance no tempo"
            />
          </RadioGroup>
        </FormControl>
        {selectedValue === "Radiografia dos PDVs" && (
          <>
            <LayoutCardsWrapper>
              <Grid container rowGap={2}>
                <LayoutCardWrapper
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "16px",
                    height: "369px",
                  }}
                >
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Lojas das redes: ",
                    }}
                    exportTable
                    exportContainer
                    exportTableId="spNRe"
                    style={{ width: "100%", height: "100%" }}
                    className={"container-table"}
                  >
                    <div className="container-total-store">
                      <h3>Total de Lojas:</h3>
                      <NativeObject
                        app={app}
                        key="TgXuau"
                        reference={{ id: "TgXuau" }}
                        className="container-number-store"
                      />
                    </div>
                    <NativeObject
                      app={app}
                      key="spNRe"
                      reference={{ id: "spNRe" }}
                    />
                  </Card>
                </LayoutCardWrapper>
              </Grid>

              <Grid item width={"100%"}>
                <LayoutCardWrapper
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "16px",
                    height: "390px",
                  }}
                  className={"container-table"}
                >
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Segmento de cada agrupamento de loja ",
                    }}
                    exportTable
                    exportContainer
                    exportTableId="pnfjYy"
                    style={{ width: "100%", height: "100%" }}
                    className={"container-table"}
                  >
                    <NativeObject
                      app={app}
                      key="pnfjYy"
                      reference={{ id: "pnfjYy" }}
                    />
                  </Card>
                </LayoutCardWrapper>
              </Grid>

              <Grid item width={"100%"}>
                <LayoutCardWrapper
                  style={{
                    paddingLeft: "10px",
                    marginBottom: "16px",
                    height: "390px",
                  }}
                  className={"container-table"}
                >
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Performance por grupo PDV Premiado ",
                    }}
                    exportTable
                    exportTableId="mxscjm"
                    style={{ width: "100%", height: "100%" }}
                    className={"container-table"}
                  >
                    <NativeObject
                      app={app}
                      key="mxscjm"
                      reference={{ id: "mxscjm" }}
                    />
                  </Card>
                </LayoutCardWrapper>
              </Grid>
            </LayoutCardsWrapper>
          </>
        )}

        {selectedValue === "Peformance no tempo" && (
          <PeformanceTimeDesktop app={app} config={config} />
        )}
      </div>
    </div>
  );
}

OpportunitiesDesktop.defaultProps = {
  app: null,
  config: {},
};

OpportunitiesDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OpportunitiesDesktop;
